export default "/_next/static/images/2017-40599487b93abc9298901c5c103e6074.svg";